<template>
    <div class="full-page comm">
        <section class="comm-section-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="text-wrapper">
                            <h3>规划你的成长目标</h3>
                            <h4>基于技能与能力评估而动态制定的，当用户实现既定目标后，系统会自动给用户提出新的技能目标，确保用户一直有明确的努力方向。</h4>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="img-wrapper"><img src="https://static.shiyanlou.com/frontend/dist/img/893c7d6.png">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="comm-section-advantage">
            <div class="container">
                <div class="row">
                    <div class="panel !col-md-4">
                        <div class="top"></div>
                        <div class="block">
                            <div class="img"><img
                                    src="//edu-image.nosdn.127.net/ef7f1cf6a9f14b17a2486f3627f3eb09.png"></div>
                            <div class="main-title">职业发展目标</div>
                            <div class="desc">根据目前的职位和个人信息，评估您在同类职业中的发展前景</div>
                            <div class="list-item"><i class="point"></i>近、中、远期职业目标</div>
                            <div class="list-item"><i class="point"></i>职业规划的基础</div>
                            <div class="list-item"><i class="point"></i>成长计划的依据</div>
                            <div class="btn">
                                <a href="#" class="ux-btn th-bk-main" @click="click_btn">职业发展目标</a>
                            </div>

                        </div>
                    </div>
                    <div class="panel !col-md-4">
                        <div class="top"></div>
                        <div class="block">
                            <div class="img"><img
                                    src="//edu-image.nosdn.127.net/26669927ae4d434e80fb75528b890237.png"></div>
                            <div class="main-title">专业技能目标</div>
                            <div class="desc">汇总最全面的人力资源管理实操工作，六大模块，一百多项专业技能</div>
                            <div class="list-item"><i class="point"></i>深入人力资源各业务模块</div>
                            <div class="list-item"><i class="point"></i>全面、实用、针对性强</div>
                            <div class="list-item"><i class="point"></i>解决管理实际问题</div>
                            <div class="list-item"><i class="point second"></i>技能提升有梯度</div>
                            <div class="list-item"><i class="point second"></i>升值加薪必备</div>
                            <div class="btn">
                                <a href="#" class="ux-btn th-bk-main" @click="click_skill_hr_btn">专业技能目标</a>
                            </div>

                        </div>
                    </div>
                    <div class="panel !col-md-4">
                        <div class="top"></div>
                        <div class="block">
                            <div class="img"><img
                                    src="//edu-image.nosdn.127.net/b85ea16aa5cf41c488693cc1c863e91f.png"></div>
                            <div class="main-title">通用能力目标</div>
                            <div class="desc">职位通用的能力要求</div>
                            <div class="list-item"><i class="point"></i>沟通技巧、团队管理、创新能力</div>
                            <div class="list-item"><i class="point"></i>解决问题能力</div>
                            <div class="list-item"><i class="point"></i>情绪管理能力</div>
                            <div class="list-item"><i class="point"></i>持续学习能力</div>
                            <div class="list-item"><i class="point second"></i>时间管理能力</div>
                            <div class="list-item"><i class="point second"></i>现代办公技能等</div>
                            <div class="btn">
                                <a href="#" class="ux-btn th-bk-main" @click="click_skill_common_btn">通用能力目标</a>
                            </div>

                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </section>
        <section class="comm-section-webpage">
            <div class="container">
                <div class="comm-presentation">
                    <div class="comm-presentation-img left"><img
                            src="https://static.shiyanlou.com/frontend/dist/img/832a1df.png"></div>
                    <div class="comm-presentation-text"><h4>职位发展目标</h4>
                        <div>
                            职位发展评估由系统自动完成：评估目前的职位、薪资与该职位的从业人员的比较分析。
                        </div>
                    </div>
                </div>
                <div class="comm-presentation">
                    <div class="comm-presentation-img right"><img
                            src="https://static.shiyanlou.com/frontend/dist/img/452cab5.png"></div>
                    <div class="comm-presentation-text"><h4>HR专项技能目标</h4>
                        <div>
                            HR专项技能包含人力资源六大知识模块及相关工作技能。
                        </div>
                    </div>
                </div>
                <div class="comm-presentation">
                    <div class="comm-presentation-img left"><img
                            src="https://static.shiyanlou.com/frontend/dist/img/3ed4bcf.png"></div>
                    <div class="comm-presentation-text"><h4>通用管理能力目标</h4>
                        <div>
                            通用管理能力。
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
    // import LiveCourseCard from '@/components/common_components/cards/live_course_card.vue'

    import {mapState, mapActions} from 'vuex'

    export default {
        components: {},
        computed: {
            ...mapState({
                not_ended_live_courses: state => state.live.not_ended_live_courses,
                ended_live_courses: state => state.live.ended_live_courses,
                sign_on: state => state.loginState.sign_on
            })
        },
         methods: {
            ...mapActions({
                // set_start_btn_infos: 'eval_position/set_state_btn_info',
                change_show_state: 'loginState/change_show_state',
            }),
            click_btn: function () {
                if(!this.sign_on){
                    this.change_show_state('on')
                }else{
                    this.$router.push({name: 'position_target'})
                }
            },
            click_skill_hr_btn: function () {
                if(!this.sign_on){
                    this.change_show_state('on')
                }else{
                    this.$router.push({name: 'skill_target_with_id', params: {id: 'hr'}})
                }
            },
            click_skill_common_btn: function () {
                if(!this.sign_on){
                    this.change_show_state('on')
                }else{
                    this.$router.push({name: 'skill_target_with_id', params: {id: 'common'}})
                }
            }

        },
    }
</script>
<style type="text/css" scoped>

    .row {
        display: -webkit-box;
        display: flex;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
    }

    .text-wrapper {
        margin-top: 65px;
        margin-left: 30px;
    }

    .text-wrapper > h3 {
        margin: 0;
        font-size: 35px;
        font-weight: 400;
        color: #fff;
    }

    .text-wrapper > h4 {
        margin: 20px 0 70px;
        font-size: 20px;
        font-weight: 400;
        color: #eee;
    }

    .text-wrapper .btn-groups > a:first-of-type {
        margin-right: 30px;
    }

    .text-wrapper .btn-groups > a {
        width: 194px;
        height: 44px;
        line-height: 29px;
    }

    .comm {
        background: url(/static/img/bg_s_2.png) no-repeat;
        background-color: #fff;
    }

    .comm section {
        padding: 1px 0;
    }

    .img-wrapper {
        display: inline-block;
        width: 420px;

    }

    .img-wrapper img {
        height: 285px;
        margin-top: 8px;
    }

    img {
        vertical-align: middle;
        max-width: 100%;
        height: auto;
    }

    .comm-presentation {
        width: 90%;
        margin: 100px auto;
        overflow: hidden;
    }

    .comm-presentation .comm-presentation-img {
        margin-right: 20px;
        filter: blur(2px);
        -webkit-filter: blur(2px);
    }

    .comm-presentation .left {
        float: left;
    }

    .comm-presentation .right {
        float: right;
    }

    .comm-presentation .comm-presentation-img img {
        max-width: 560px;
    }

    .comm-presentation .comm-presentation-text {
        margin-top: 100px;
        width: auto;
        font-size: 20px;
        color: #666;
    }


    .common_page_header {
        width: 100%;
        height: 200px;
        margin-top: -20px;
        background: url("https://static.shiyanlou.com/frontend/dist/img/893c7d6.png");
        background-position: 50%;
        background-size: cover;
    }

    .common_page_content {
        width: 1170px;
        margin: auto;
        padding: 30px;
    }

    .common_description_title {
        margin: 45px 0 26px;
        color: #666;
    }

    .no_courses_warning {
        color: #a4a4a4;
        font-size: 18px;
    }

    .common_ended_courses {
        display: flex;
        flex-wrap: wrap;
    }

    .common_courses_card {
        width: 33.333%
    }

    .panel {
        width: 320px;
        height: 440px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        margin: 25px;
        background-color: #fff;
    }

    .panel .top {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        position: absolute;
        width: 100%;
        height: 3px;
        background: transparent;
    }

    .panel .block {
        width: 100%;
        height: 100%;
        padding: 0 18px 0 18px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .panel .block .img {
        width: 125px;
        height: 103px;
        margin: 27px auto 3px auto;
    }

    .panel .block .main-title {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 20px;
        color: #333;
        line-height: 18px;
        margin: 8px 10px;
    }

    .panel .block .desc {
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 14px;
        color: #999;
        line-height: 22px;
        margin-bottom: 10px;
    }

    .panel .block .list-item {
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 14px;
        color: #666;
        line-height: 25px;
        margin-left: 0px;
    }

    .panel .block .list-item .point {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #578BFF;
        display: inline-block;
        margin-right: 8px;
        vertical-align: middle;
    }

    .panel .block .list-item .point.second {
        background: #FF9C00;
    }

    .panel .block .btn {
        position: absolute;
        bottom: 32px;
        text-align: center;
        width: 284px;
    }

    .ux-btn {
        -webkit-appearance: none;
        margin: 0;
        overflow: visible;
        text-transform: none;
        text-decoration: none;
        cursor: pointer;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        padding: 0 12px;
        height: 34px;
        line-height: 34px;
        border-width: 1px;
        border-style: solid;
        font-size: 14px;
        border-radius: 2px;
    }

    .panel .btn .ux-btn.th-bk-main {
        -webkit-transition: all 0.2s linear 0s;
        transition: all 0.2s linear 0s;
        color: #578BFF;
        border: solid 1px #578BFF;
        border-radius: 2px;
        font-family: -apple-system, PingFang SC, "Microsoft YaHei", MicrosoftYaHei, "Arial", "Hiragino Sans GB", \5fae\8f6f\96c5\9ed1, "Helvetica", "sans-serif";
        font-size: 16px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: auto;
        line-height: initial;
        background: #fff;
        padding: 11px 40px;
    }

    .panel:hover {
        -webkit-box-shadow: 0 2px 35px 0 rgba(118, 154, 235, 0.25);
        box-shadow: 0 2px 35px 0 rgba(118, 154, 235, 0.25);
    }

    .panel:hover .top {
        background: #578BFF;
    }

    .panel:hover .block .main-title {
        color: #578BFF;
    }

    .panel:hover .block .btn .ux-btn.th-bk-main {
        color: #fff;
        background: #578bff;
    }

    .panel:hover .block .btn .ux-btn.th-bk-main {
        color: #fff;
        background: #578bff;
    }
</style>